/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
    readonly " $refType": "PdpSharedDetailReference_user";
};
export type PdpSharedDetailReference_user$data = PdpSharedDetailReference_user;
export type PdpSharedDetailReference_user$key = {
    readonly " $data"?: PdpSharedDetailReference_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReference_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '240620978a1a7e3a4b00cfdd667faab9';
export default node;
